/* src/app/sections/inputs-section/inputs-section.component.css */
/*# sourceMappingURL=inputs-section.component.css.map */
